import { useParams as useParamsBase } from 'react-router-dom'
import { LocationParams } from '../typings/LocationParams'

export function useParams(): LocationParams {
  return useParamsBase() as unknown as LocationParams
}
